import ServiceApi from "../ServiceApi";

class StoreServiceApi extends ServiceApi {
  constructor() {
    super("storeService", "store");
  }

  /**
   *
   * @param {array} tags
   * @param {array} states, e.g. 'Available'
   */
  getOffers(tags, states) {
    const params = {};
    if (tags) params.tags = tags;
    if (states) params.states = states;
    return this.request("getOffers", params);
  }
  /**
   * @deprecated
   * @param {string} offer_uuid - offer unique id in project
   * @param {string} source - possible values: web (from website), ingame (GC frame)
   * @param {string} return_url - waiting page to payment frame
   * @param {string} currency - offer's currency
   */
  buyOffer(offer_uuid, source = "web", return_url = "", currency) {
    const request_data = { offerUuid: offer_uuid, source };
    if (return_url) {
      request_data.returnUrl = return_url;
    }
    if (currency) {
      request_data.currency = currency;
    }
    return this.request("buyOffer", request_data);
  }

  /**
   *
   * @param {object} params
   * @param {string} params.offerUuid
   * @param {string} params.return_url
   * @param {string} [params.source]
   * @param {number} [params.amount]
   * @param {string} [params.target]
   * @param {string} [params.shardName]
   * @param {number} [params.avatarId]
   */
  buyOfferNew(params) {
    if (!params.source) {
      params.source = "web";
    }
    return this.request("buyOffer", params);
  }

  /**
   * @param {string} invoice_uuid
   */
  checkInvoice(invoice_uuid) {
    return this.request("getInvoiceStatus", { invoiceUuid: invoice_uuid });
  }

  getGuildOffer() {
    return this.getOffers(["guild-pack"]);
  }

  /**
   * gets information about offer(s)
   * @param {object} params
   * @param params.offerNames {array}
   */
  getOffersMeta(params) {
    return this.request("getOffersMeta", params);
  }

  /**
   *  gets information about item(s)
   * @param {object} params
   * @param params.contentNames {array}
   */
  getContentsMeta(params) {
    return this.request("getContentsMeta", params);
  }

  /**
   *  gets information about offer(s) and item(s) inside
   * @param {object} params
   * @param params.offerNames {array}
   */
  getOffersWithContentsMeta(params) {
    return this.request("offersWithContentsMeta", params);
  }

  /**
   * By this method user can buy more than one offer
   * @param {Array} offers, must be an array with offerNames
   */
  buyMultipleOffers(offers) {
    const params = {
      offersNames: offers,
    };

    return this.request("buyMultipleOffers", params);
  }

  /**
   *
   * @param {object} params
   * @param params.offerName {string}
   * @param params.currency {string}
   * @param params.amount {number} optional
   * @param params.shardName {string} optional
   * @param params.avatarId {number} optional
   * @param params.source {string} - optional, possible values: web (from website), ingame (GC frame)
   */
  buyOfferWithInternalCurrency(params) {
    return this.request("buyOfferWithInternalCurrency", params);
  }

  /**
   * Get purchased external promo codes
   * @param {number} page
   * @param {number} per_page
   * @returns {*}
   * response example:
   * {
  "data": [
    {
      "acquired_at": 1629386459,
      "code": "K7L68DW92GLrmDLo",
      "name": "string"
    }
  ],
  "meta": {
    "current_page": 1,
    "from": 1,
    "last_page": 1,
    "per_page": 25,
    "to": 1,
    "total": 1
  }
}
   */
  getExternalPromoCodes(page = 1, per_page = 10) {
    const params = { page, perPage: per_page };
    return this.request("getExternalPromoCodes", params);
  }
}
export default new StoreServiceApi();
